import { render, staticRenderFns } from "./onBoard.vue?vue&type=template&id=766b27d4&scoped=true"
import script from "./onBoard.vue?vue&type=script&lang=js"
export * from "./onBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b27d4",
  null
  
)

export default component.exports